import dynamic from 'next/dynamic'

const DefaultFooter = dynamic(
  async () => (await import('@ant-design/pro-layout')).DefaultFooter,
  { ssr: false }
)

export const Footer = () => (
  <DefaultFooter links={false} copyright="RYDE, Inc." />
)
